<div class="modal-header">
  <h4 class="modal-title fw-normal">{{ title() }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
</div>
<div class="modal-body">
  <p class="alert alert-danger">{{ alertMessage() }}</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="closeModal()">Close</button>
</div>
